// import React, { useMemo, useState } from "react";
// import {
//     Search,
//     ChevronDown,
//     LifeBuoy,
//     Clock,
//     CheckCircle2,
//     AlertCircle,
//     User,
//     Calendar,
// } from "lucide-react";

// const TICKETS = [
//     {
//         id: "TCK-1042",
//         subject: "CNC machine not responding to job start",
//         raisedBy: "Ravi Teja",
//         centre: "Vizag",
//         category: "Machine Issue",
//         priority: "High",
//         status: "Open",
//         date: "18 Jul 2026",
//         assignedTo: "Priya Nair",
//     },
//     {
//         id: "TCK-1041",
//         subject: "Unable to upload design files to project",
//         raisedBy: "Lakshmi Devi",
//         centre: "Vijayawada",
//         category: "Software",
//         priority: "Medium",
//         status: "In Progress",
//         date: "18 Jul 2026",
//         assignedTo: "Arjun Kumar",
//     },
//     {
//         id: "TCK-1039",
//         subject: "Booking slot double allocated for 3D printer",
//         raisedBy: "Sandeep Reddy",
//         centre: "Tirupati",
//         category: "Booking",
//         priority: "High",
//         status: "Open",
//         date: "17 Jul 2026",
//         assignedTo: "Unassigned",
//     },
//     {
//         id: "TCK-1036",
//         subject: "Invoice amount mismatch for last order",
//         raisedBy: "Meera Iyer",
//         centre: "Kurnool",
//         category: "Billing",
//         priority: "Low",
//         status: "Resolved",
//         date: "16 Jul 2026",
//         assignedTo: "Priya Nair",
//     },
//     {
//         id: "TCK-1033",
//         subject: "Laser cutter emitting unusual noise during operation",
//         raisedBy: "Kiran Babu",
//         centre: "Guntur",
//         category: "Machine Issue",
//         priority: "High",
//         status: "In Progress",
//         date: "15 Jul 2026",
//         assignedTo: "Arjun Kumar",
//     },
//     {
//         id: "TCK-1030",
//         subject: "Request to reset operator login credentials",
//         raisedBy: "Divya Sri",
//         centre: "Nellore",
//         category: "Access",
//         priority: "Medium",
//         status: "Resolved",
//         date: "14 Jul 2026",
//         assignedTo: "Priya Nair",
//     },
// ];

// const STATUS_STYLES = {
//     Open: "bg-red-100 text-red-700",
//     "In Progress": "bg-amber-100 text-amber-700",
//     Resolved: "bg-green-100 text-green-700",
// };

// const PRIORITY_STYLES = {
//     High: "bg-red-50 text-red-600 border border-red-200",
//     Medium: "bg-amber-50 text-amber-600 border border-amber-200",
//     Low: "bg-slate-50 text-slate-600 border border-slate-200",
// };

// function StatCard({ icon: Icon, label, value, tone }) {
//     return (
//         <div className="flex items-center gap-4 rounded-2xl border border-gray-200 bg-white p-5">
//             <span className={`flex h-11 w-11 shrink-0 items-center justify-center rounded-xl ${tone}`}>
//                 <Icon className="h-5 w-5" />
//             </span>
//             <div>
//                 <p className="text-2xl font-bold text-gray-900">{value}</p>
//                 <p className="text-sm text-gray-500">{label}</p>
//             </div>
//         </div>
//     );
// }

// export default function SupportDashboard() {
//     const [query, setQuery] = useState("");
//     const [statusFilter, setStatusFilter] = useState("All Status");
//     const [priorityFilter, setPriorityFilter] = useState("All Priority");

//     const statuses = useMemo(
//         () => ["All Status", ...new Set(TICKETS.map((t) => t.status))],
//         []
//     );
//     const priorities = useMemo(
//         () => ["All Priority", ...new Set(TICKETS.map((t) => t.priority))],
//         []
//     );

//     const counts = useMemo(() => {
//         const open = TICKETS.filter((t) => t.status === "Open").length;
//         const inProgress = TICKETS.filter((t) => t.status === "In Progress").length;
//         const resolved = TICKETS.filter((t) => t.status === "Resolved").length;
//         return { total: TICKETS.length, open, inProgress, resolved };
//     }, []);

//     const filtered = useMemo(() => {
//         return TICKETS.filter((t) => {
//             const matchesQuery =
//                 query.trim() === "" ||
//                 [t.id, t.subject, t.raisedBy, t.centre].some((field) =>
//                     field.toLowerCase().includes(query.trim().toLowerCase())
//                 );
//             const matchesStatus = statusFilter === "All Status" || t.status === statusFilter;
//             const matchesPriority = priorityFilter === "All Priority" || t.priority === priorityFilter;
//             return matchesQuery && matchesStatus && matchesPriority;
//         });
//     }, [query, statusFilter, priorityFilter]);

//     return (
//         <div className="h-screen w-full overflow-y-auto bg-gray-50 scrollbar-hide">
//             <style>{`
//                 .scrollbar-hide::-webkit-scrollbar {
//                     display: none;
//                 }
//                 .scrollbar-hide {
//                     -ms-overflow-style: none;
//                     scrollbar-width: none;
//                 }
//             `}</style>

//             <div className="p-6">
//                 {/* Page heading */}
//                 <div className="mb-6">
//                     <h1 className="text-2xl font-bold text-gray-900">Support tickets</h1>
//                     <p className="mt-1 text-sm text-gray-500">
//                         Track and resolve tickets raised across all centres
//                     </p>
//                 </div>

//                 {/* Stat cards */}
//                 <div className="mb-6 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
//                     <StatCard icon={LifeBuoy} label="Total tickets" value={counts.total} tone="bg-indigo-50 text-indigo-500" />
//                     <StatCard icon={AlertCircle} label="Open" value={counts.open} tone="bg-red-50 text-red-500" />
//                     <StatCard icon={Clock} label="In progress" value={counts.inProgress} tone="bg-amber-50 text-amber-500" />
//                     <StatCard icon={CheckCircle2} label="Resolved" value={counts.resolved} tone="bg-green-50 text-green-500" />
//                 </div>

//                 {/* Table card */}
//                 <div className="w-full rounded-2xl border border-gray-200 bg-white shadow-sm">
//                     {/* Header */}
//                     <div className="flex flex-col gap-4 border-b border-gray-100 p-6 sm:flex-row sm:items-center sm:justify-between">
//                         <div>
//                             <h2 className="text-lg font-bold text-gray-900">Raised tickets</h2>
//                             <p className="mt-1 text-sm text-gray-500">
//                                 {filtered.length} of {TICKETS.length} tickets need resolution
//                             </p>
//                         </div>

//                         <div className="flex flex-col gap-3 sm:flex-row sm:items-center">
//                             <div className="relative">
//                                 <Search className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-gray-400" />
//                                 <input
//                                     type="text"
//                                     value={query}
//                                     onChange={(e) => setQuery(e.target.value)}
//                                     placeholder="Search ticket, name, centre..."
//                                     className="w-64 rounded-lg border border-gray-200 bg-gray-50 py-2 pl-9 pr-3 text-sm text-gray-700 placeholder-gray-400 outline-none focus:border-gray-300 focus:bg-white"
//                                 />
//                             </div>

//                             <div className="relative">
//                                 <select
//                                     value={statusFilter}
//                                     onChange={(e) => setStatusFilter(e.target.value)}
//                                     className="appearance-none rounded-lg border border-gray-200 bg-white py-2 pl-3 pr-8 text-sm text-gray-700 outline-none focus:border-gray-300"
//                                 >
//                                     {statuses.map((s) => (
//                                         <option key={s} value={s}>
//                                             {s}
//                                         </option>
//                                     ))}
//                                 </select>
//                                 <ChevronDown className="pointer-events-none absolute right-2 top-1/2 h-4 w-4 -translate-y-1/2 text-gray-400" />
//                             </div>

//                             <div className="relative">
//                                 <select
//                                     value={priorityFilter}
//                                     onChange={(e) => setPriorityFilter(e.target.value)}
//                                     className="appearance-none rounded-lg border border-gray-200 bg-white py-2 pl-3 pr-8 text-sm text-gray-700 outline-none focus:border-gray-300"
//                                 >
//                                     {priorities.map((p) => (
//                                         <option key={p} value={p}>
//                                             {p}
//                                         </option>
//                                     ))}
//                                 </select>
//                                 <ChevronDown className="pointer-events-none absolute right-2 top-1/2 h-4 w-4 -translate-y-1/2 text-gray-400" />
//                             </div>
//                         </div>
//                     </div>

//                     {/* Table */}
//                     <div className="overflow-x-auto">
//                         <table className="w-full min-w-[1000px] table-fixed border-collapse text-left">
//                             <thead>
//                                 <tr className="bg-gray-50 text-xs uppercase tracking-wide text-gray-400">
//                                     <th className="w-[26%] px-6 py-3 font-medium">Ticket</th>
//                                     <th className="w-[14%] px-6 py-3 font-medium">Raised by</th>
//                                     <th className="w-[12%] px-6 py-3 font-medium">Category</th>
//                                     <th className="w-[10%] px-6 py-3 font-medium">Priority</th>
//                                     <th className="w-[12%] px-6 py-3 font-medium">Status</th>
//                                     <th className="w-[12%] px-6 py-3 font-medium">Date</th>
//                                     <th className="w-[14%] px-6 py-3 font-medium">Assigned to</th>
//                                 </tr>
//                             </thead>
//                             <tbody>
//                                 {filtered.map((t, idx) => (
//                                     <tr
//                                         key={t.id}
//                                         className={`text-sm ${idx !== filtered.length - 1 ? "border-b border-gray-100" : ""}`}
//                                     >
//                                         <td className="px-6 py-4">
//                                             <p className="font-semibold text-gray-900">{t.subject}</p>
//                                             <p className="mt-0.5 text-xs text-gray-400">
//                                                 {t.id} · {t.centre}
//                                             </p>
//                                         </td>
//                                         <td className="px-6 py-4 text-gray-600">
//                                             <div className="flex items-center gap-2">
//                                                 <User className="h-4 w-4 shrink-0 text-gray-400" />
//                                                 <span className="truncate">{t.raisedBy}</span>
//                                             </div>
//                                         </td>
//                                         <td className="px-6 py-4 text-gray-600">{t.category}</td>
//                                         <td className="px-6 py-4">
//                                             <span className={`inline-flex rounded-full px-3 py-1 text-xs font-medium ${PRIORITY_STYLES[t.priority]}`}>
//                                                 {t.priority}
//                                             </span>
//                                         </td>
//                                         <td className="px-6 py-4">
//                                             <span className={`inline-flex rounded-full px-3 py-1 text-xs font-medium ${STATUS_STYLES[t.status]}`}>
//                                                 {t.status}
//                                             </span>
//                                         </td>
//                                         <td className="px-6 py-4 text-gray-500">
//                                             <div className="flex items-center gap-1.5">
//                                                 <Calendar className="h-4 w-4 shrink-0 text-gray-400" />
//                                                 {t.date}
//                                             </div>
//                                         </td>
//                                         <td className="px-6 py-4 text-gray-600">
//                                             {t.assignedTo === "Unassigned" ? (
//                                                 <span className="text-gray-400">Unassigned</span>
//                                             ) : (
//                                                 t.assignedTo
//                                             )}
//                                         </td>
//                                     </tr>
//                                 ))}

//                                 {filtered.length === 0 && (
//                                     <tr>
//                                         <td colSpan={7} className="px-6 py-10 text-center text-sm text-gray-400">
//                                             No tickets match your filters.
//                                         </td>
//                                     </tr>
//                                 )}
//                             </tbody>
//                         </table>
//                     </div>
//                 </div>
//             </div>
//         </div>
//     );
// }


import React, { useEffect, useMemo, useState } from "react";
import {
    Search,
    ChevronDown,
    LifeBuoy,
    Clock,
    CheckCircle2,
    AlertCircle,
    User,
    Calendar,
    X,
    Eye,
    Tag,
    Building2,
    Loader2,
} from "lucide-react";
import { getSupportTickets, updateSupportTicketStatus } from "../service/userService";

const STATUS_STYLES = {
    Open: "bg-red-100 text-red-700",
    "In Progress": "bg-amber-100 text-amber-700",
    Resolved: "bg-green-100 text-green-700",
    Closed: "bg-gray-100 text-gray-700",
};

const PRIORITY_STYLES = {
    High: "bg-red-50 text-red-600 border border-red-200",
    Medium: "bg-amber-50 text-amber-600 border border-amber-200",
    Low: "bg-slate-50 text-slate-600 border border-slate-200",
};

const STATUS_OPTIONS = ["OPEN", "IN_PROGRESS", "RESOLVED", "CLOSED"];

/* ---------------------------------------------------------
   Enum <-> display-label helpers
--------------------------------------------------------- */
function toTitleCase(value) {
    if (!value) return "";
    return value
        .toLowerCase()
        .split("_")
        .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
        .join(" ");
}

function toEnumCase(label) {
    if (!label) return "";
    return label.toUpperCase().replace(/\s+/g, "_");
}

function statusEnumToLabel(status) {
    return toTitleCase(status);
}

function getRaisedByLabel(t) {
    const idPart = t.userId ?? t.vendorId ?? t.expertId;
    const typeLabel = t.userType ? toTitleCase(t.userType) : "User";
    return idPart ? `${typeLabel} #${idPart}` : typeLabel;
}

function formatDateLabel(iso) {
    if (!iso) return "-";
    const d = new Date(iso);
    if (Number.isNaN(d.getTime())) return "-";
    return d.toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" });
}

function toISODateOnly(iso) {
    if (!iso) return "";
    const d = new Date(iso);
    if (Number.isNaN(d.getTime())) return "";
    const yyyy = d.getFullYear();
    const mm = String(d.getMonth() + 1).padStart(2, "0");
    const dd = String(d.getDate()).padStart(2, "0");
    return `${yyyy}-${mm}-${dd}`;
}

// Maps a raw API ticket into the shape the UI works with
function mapApiTicket(raw) {
    return {
        id: raw.id,
        displayId: `TCK-${raw.id}`,
        subject: raw.subject || "(No subject)",
        description: raw.message || "",
        raisedBy: getRaisedByLabel(raw),
        centre: "—", // not provided by the API
        category: raw.category ? toTitleCase(raw.category) : "-",
        priority: raw.priority ? toTitleCase(raw.priority) : "Low",
        status: raw.status ? toTitleCase(raw.status) : "Open",
        date: formatDateLabel(raw.createdAt),
        rawDate: toISODateOnly(raw.createdAt),
        assignedTo: raw.assignedTo || "Unassigned",
        resolutionNote: "", // API has no dedicated field for this
    };
}

/* ---------------------------------------------------------
   Date helpers (for filter dropdown)
--------------------------------------------------------- */
function toISODate(d) {
    const yyyy = d.getFullYear();
    const mm = String(d.getMonth() + 1).padStart(2, "0");
    const dd = String(d.getDate()).padStart(2, "0");
    return `${yyyy}-${mm}-${dd}`;
}

function formatISOForLabel(iso) {
    const d = new Date(`${iso}T00:00:00`);
    return d.toLocaleDateString("en-GB", { day: "2-digit", month: "short" });
}

function StatCard({ icon: Icon, label, value, tone }) {
    return (
        <div className="flex items-center gap-4 rounded-2xl border border-gray-200 bg-white p-5">
            <span className={`flex h-11 w-11 shrink-0 items-center justify-center rounded-xl ${tone}`}>
                <Icon className="h-5 w-5" />
            </span>
            <div>
                <p className="text-2xl font-bold text-gray-900">{value}</p>
                <p className="text-sm text-gray-500">{label}</p>
            </div>
        </div>
    );
}

/* ---------------------------------------------------------
   Date filter dropdown — Today / Yesterday / Custom range
--------------------------------------------------------- */
function DateFilterDropdown({ dateFilter, customRange, onChange }) {
    const [open, setOpen] = useState(false);
    const [start, setStart] = useState(customRange.start);
    const [end, setEnd] = useState(customRange.end);

    const label =
        dateFilter === "today"
            ? "Today"
            : dateFilter === "yesterday"
                ? "Yesterday"
                : dateFilter === "custom" && customRange.start && customRange.end
                    ? `${formatISOForLabel(customRange.start)} - ${formatISOForLabel(customRange.end)}`
                    : "All dates";

    const selectPreset = (preset) => {
        onChange(preset, { start: "", end: "" });
        setStart("");
        setEnd("");
        setOpen(false);
    };

    const applyCustom = () => {
        if (!start || !end) return;
        onChange("custom", { start, end });
        setOpen(false);
    };

    const optionClass = (active) =>
        `w-full rounded-lg px-3 py-2 text-left text-sm font-medium transition ${active ? "bg-indigo-50 text-indigo-700" : "text-gray-600 hover:bg-gray-50"
        }`;

    return (
        <div className="relative">
            <button
                onClick={() => setOpen((o) => !o)}
                className="flex items-center gap-2 rounded-lg border border-gray-200 bg-white py-2 pl-3 pr-3 text-sm text-gray-700 outline-none transition hover:border-gray-300"
            >
                <Calendar className="h-4 w-4 text-gray-400" />
                <span>{label}</span>
                <ChevronDown className="h-4 w-4 text-gray-400" />
            </button>

            {open && (
                <>
                    <div className="fixed inset-0 z-40" onClick={() => setOpen(false)} />
                    <div className="absolute right-0 z-50 mt-2 w-64 rounded-xl border border-gray-200 bg-white p-3 shadow-lg">
                        <button onClick={() => selectPreset("all")} className={optionClass(dateFilter === "all")}>
                            All dates
                        </button>
                        <button onClick={() => selectPreset("today")} className={optionClass(dateFilter === "today")}>
                            Today
                        </button>
                        <button
                            onClick={() => selectPreset("yesterday")}
                            className={optionClass(dateFilter === "yesterday")}
                        >
                            Yesterday
                        </button>

                        <div className="mt-2 border-t border-gray-100 pt-3">
                            <p className="mb-2 text-xs font-semibold uppercase tracking-wide text-gray-400">
                                Custom range
                            </p>
                            <div className="flex items-center gap-2">
                                <input
                                    type="date"
                                    value={start}
                                    onChange={(e) => setStart(e.target.value)}
                                    className="w-full rounded-lg border border-gray-200 px-2 py-1.5 text-xs text-gray-700 outline-none focus:border-gray-300"
                                />
                                <span className="text-xs text-gray-400">to</span>
                                <input
                                    type="date"
                                    value={end}
                                    onChange={(e) => setEnd(e.target.value)}
                                    className="w-full rounded-lg border border-gray-200 px-2 py-1.5 text-xs text-gray-700 outline-none focus:border-gray-300"
                                />
                            </div>
                            <button
                                onClick={applyCustom}
                                disabled={!start || !end}
                                className={`mt-2 w-full rounded-lg px-3 py-1.5 text-xs font-semibold transition ${start && end
                                    ? "bg-gradient-to-r from-blue-500 to-indigo-600 text-white hover:opacity-90"
                                    : "cursor-not-allowed bg-gray-100 text-gray-400"
                                    }`}
                            >
                                Apply range
                            </button>
                        </div>
                    </div>
                </>
            )}
        </div>
    );
}

/* ---------------------------------------------------------
   Ticket detail / status-update modal
--------------------------------------------------------- */
function TicketModal({ ticket, onClose, onUpdateStatus, saving }) {
    const [reason, setReason] = useState(ticket.resolutionNote || "");
    const [selectedStatus, setSelectedStatus] = useState(toEnumCase(ticket.status));

    const requiresReason = selectedStatus === "RESOLVED" || selectedStatus === "CLOSED";
    const statusChanged = selectedStatus !== toEnumCase(ticket.status);
    const canSubmit = statusChanged && (!requiresReason || reason.trim());

    const handleUpdate = () => {
        if (!canSubmit) return;
        onUpdateStatus(ticket.id, selectedStatus, reason.trim());
    };

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
            <div className="absolute inset-0 bg-gray-900/50" onClick={onClose} />
            <div className="relative w-full max-w-lg max-h-[90vh] overflow-y-auto rounded-2xl bg-white shadow-xl">
                {/* Header */}
                <div className="sticky top-0 flex items-start justify-between gap-3 border-b border-gray-100 bg-white px-6 py-5">
                    <div>
                        <p className="text-xs font-semibold text-gray-400">{ticket.displayId}</p>
                        <h2 className="mt-0.5 text-base font-bold text-gray-900">{ticket.subject}</h2>
                    </div>
                    <button onClick={onClose} className="shrink-0 p-1 text-gray-400 transition hover:text-gray-700">
                        <X className="h-5 w-5" />
                    </button>
                </div>

                <div className="space-y-5 px-6 py-5">
                    {/* Meta row */}
                    <div className="flex flex-wrap items-center gap-2">
                        <span className={`inline-flex rounded-full px-3 py-1 text-xs font-medium ${STATUS_STYLES[ticket.status] || STATUS_STYLES.Open}`}>
                            {ticket.status}
                        </span>
                        <span className={`inline-flex rounded-full px-3 py-1 text-xs font-medium ${PRIORITY_STYLES[ticket.priority] || PRIORITY_STYLES.Low}`}>
                            {ticket.priority} priority
                        </span>
                    </div>

                    {/* Details grid */}
                    <div className="grid grid-cols-2 gap-4 rounded-xl bg-gray-50 p-4 text-sm">
                        <div className="flex items-center gap-2 text-gray-600">
                            <User className="h-4 w-4 shrink-0 text-gray-400" />
                            <span>{ticket.raisedBy}</span>
                        </div>
                        <div className="flex items-center gap-2 text-gray-600">
                            <Building2 className="h-4 w-4 shrink-0 text-gray-400" />
                            <span>{ticket.centre}</span>
                        </div>
                        <div className="flex items-center gap-2 text-gray-600">
                            <Tag className="h-4 w-4 shrink-0 text-gray-400" />
                            <span>{ticket.category}</span>
                        </div>
                        <div className="flex items-center gap-2 text-gray-600">
                            <Calendar className="h-4 w-4 shrink-0 text-gray-400" />
                            <span>{ticket.date}</span>
                        </div>
                    </div>

                    {/* Description */}
                    <div>
                        <p className="mb-1.5 text-xs font-semibold uppercase tracking-wide text-gray-400">
                            Description
                        </p>
                        <p className="text-sm leading-relaxed text-gray-700">{ticket.description}</p>
                    </div>

                    {/* Assigned to */}
                    <div>
                        <p className="mb-1.5 text-xs font-semibold uppercase tracking-wide text-gray-400">
                            Assigned to
                        </p>
                        <p className="text-sm text-gray-700">
                            {ticket.assignedTo === "Unassigned" ? (
                                <span className="text-gray-400">Unassigned</span>
                            ) : (
                                ticket.assignedTo
                            )}
                        </p>
                    </div>

                    {/* Status dropdown */}
                    <div>
                        <label className="mb-1.5 block text-xs font-semibold uppercase tracking-wide text-gray-400">
                            Status
                        </label>
                        <div className="relative">
                            <select
                                value={selectedStatus}
                                onChange={(e) => setSelectedStatus(e.target.value)}
                                disabled={saving}
                                className="w-full appearance-none rounded-lg border border-gray-200 bg-white px-3 py-2.5 pr-9 text-sm text-gray-700 outline-none focus:border-gray-300 disabled:cursor-not-allowed disabled:bg-gray-100"
                            >
                                {STATUS_OPTIONS.map((s) => (
                                    <option key={s} value={s}>
                                        {statusEnumToLabel(s)}
                                    </option>
                                ))}
                            </select>
                            <ChevronDown className="pointer-events-none absolute right-3 top-1/2 h-4 w-4 -translate-y-1/2 text-gray-400" />
                        </div>
                    </div>

                    {/* Resolution reason */}
                    <div>
                        <label className="mb-1.5 block text-xs font-semibold uppercase tracking-wide text-gray-400">
                            Resolution note {requiresReason ? "" : "(optional)"}
                        </label>
                        <textarea
                            value={reason}
                            onChange={(e) => setReason(e.target.value)}
                            rows={4}
                            placeholder="Describe how this ticket was handled..."
                            className="w-full resize-none rounded-lg border border-gray-200 bg-gray-50 px-3 py-2.5 text-sm text-gray-700 outline-none placeholder-gray-400 focus:border-gray-300 focus:bg-white"
                        />
                        {requiresReason && !reason.trim() && (
                            <p className="mt-1 text-xs text-gray-400">
                                Add a note before marking this ticket as {statusEnumToLabel(selectedStatus).toLowerCase()}.
                            </p>
                        )}
                    </div>
                </div>

                {/* Footer actions */}
                <div className="sticky bottom-0 flex items-center justify-end gap-3 border-t border-gray-100 bg-white px-6 py-4">
                    <button
                        onClick={onClose}
                        className="px-4 py-2.5 text-sm font-semibold text-gray-500 transition hover:text-gray-800"
                    >
                        Close
                    </button>
                    <button
                        onClick={handleUpdate}
                        disabled={!canSubmit || saving}
                        className={`flex items-center gap-2 rounded-lg px-5 py-2.5 text-sm font-semibold transition ${canSubmit && !saving
                            ? "bg-gradient-to-r from-emerald-500 to-green-600 text-white hover:opacity-90"
                            : "cursor-not-allowed bg-gray-100 text-gray-400"
                            }`}
                    >
                        {saving ? (
                            <Loader2 className="h-4 w-4 animate-spin" />
                        ) : (
                            <CheckCircle2 className="h-4 w-4" />
                        )}
                        {saving ? "Saving..." : "Update status"}
                    </button>
                </div>
            </div>
        </div>
    );
}

export default function SupportDashboard() {
    const [tickets, setTickets] = useState([]);
    const [loading, setLoading] = useState(true);
    const [loadError, setLoadError] = useState("");
    const [savingTicketId, setSavingTicketId] = useState(null);

    const [query, setQuery] = useState("");
    const [statusFilter, setStatusFilter] = useState("All Status");
    const [priorityFilter, setPriorityFilter] = useState("All Priority");
    const [dateFilter, setDateFilter] = useState("all"); // "all" | "today" | "yesterday" | "custom"
    const [customRange, setCustomRange] = useState({ start: "", end: "" });
    const [activeTicketId, setActiveTicketId] = useState(null);

    const fetchTickets = async () => {
        setLoading(true);
        setLoadError("");
        try {
            const data = await getSupportTickets();
            console.log("Support tickets raw response:", data);
            if (!Array.isArray(data)) {
                console.warn("Response was not an array — check if it's wrapped, e.g. data.tickets or data.data");
            }
            const mapped = (Array.isArray(data) ? data : []).map(mapApiTicket);
            setTickets(mapped);
        } catch (err) {
            console.error("Support ticket fetch failed:", err);
            console.error("err.response?.status:", err.response?.status);
            console.error("err.response?.data:", err.response?.data);
            console.error("err.message:", err.message);
            setLoadError(
                err.response
                    ? `Couldn't load support tickets (${err.response.status}). Please try again.`
                    : "Couldn't load support tickets — check console/network tab for details."
            );
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchTickets();
    }, []);

    const statuses = useMemo(
        () => ["All Status", ...new Set(tickets.map((t) => t.status))],
        [tickets]
    );
    const priorities = useMemo(
        () => ["All Priority", ...new Set(tickets.map((t) => t.priority))],
        [tickets]
    );

    const counts = useMemo(() => {
        const open = tickets.filter((t) => t.status === "Open").length;
        const inProgress = tickets.filter((t) => t.status === "In Progress").length;
        const resolved = tickets.filter((t) => t.status === "Resolved" || t.status === "Closed").length;
        return { total: tickets.length, open, inProgress, resolved };
    }, [tickets]);

    const handleDateFilterChange = (preset, range) => {
        setDateFilter(preset);
        setCustomRange(range);
    };

    const filtered = useMemo(() => {
        const todayISO = toISODate(new Date());
        const yesterdayISO = toISODate(new Date(Date.now() - 24 * 60 * 60 * 1000));

        return tickets.filter((t) => {
            const matchesQuery =
                query.trim() === "" ||
                [t.displayId, t.subject, t.raisedBy, t.centre].some((field) =>
                    (field || "").toLowerCase().includes(query.trim().toLowerCase())
                );
            const matchesStatus = statusFilter === "All Status" || t.status === statusFilter;
            const matchesPriority = priorityFilter === "All Priority" || t.priority === priorityFilter;

            let matchesDate = true;
            if (dateFilter === "today") {
                matchesDate = t.rawDate === todayISO;
            } else if (dateFilter === "yesterday") {
                matchesDate = t.rawDate === yesterdayISO;
            } else if (dateFilter === "custom" && customRange.start && customRange.end) {
                matchesDate = t.rawDate >= customRange.start && t.rawDate <= customRange.end;
            }

            return matchesQuery && matchesStatus && matchesPriority && matchesDate;
        });
    }, [tickets, query, statusFilter, priorityFilter, dateFilter, customRange]);

    const activeTicket = tickets.find((t) => t.id === activeTicketId) || null;

    const updateTicketStatus = async (id, status, note) => {
        setSavingTicketId(id);
        try {
            await updateSupportTicketStatus(id, status);
            setTickets((list) =>
                list.map((t) =>
                    t.id === id
                        ? { ...t, status: statusEnumToLabel(status), resolutionNote: note || t.resolutionNote }
                        : t
                )
            );
            setActiveTicketId(null);
        } catch (err) {
            alert("Failed to update ticket status. Please try again.");
        } finally {
            setSavingTicketId(null);
        }
    };

    return (
        <div className="h-screen w-full overflow-y-auto bg-gray-50 scrollbar-hide">
            <style>{`
                .scrollbar-hide::-webkit-scrollbar {
                    display: none;
                }
                .scrollbar-hide {
                    -ms-overflow-style: none;
                    scrollbar-width: none;
                }
            `}</style>

            <div className="p-6">
                {/* Page heading */}
                <div className="mb-6">
                    <h1 className="text-2xl font-bold text-gray-900">Support tickets</h1>
                    <p className="mt-1 text-sm text-gray-500">
                        Track and resolve tickets raised across all centres
                    </p>
                </div>

                {/* Stat cards */}
                <div className="mb-6 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
                    <StatCard icon={LifeBuoy} label="Total tickets" value={counts.total} tone="bg-indigo-50 text-indigo-500" />
                    <StatCard icon={AlertCircle} label="Open" value={counts.open} tone="bg-red-50 text-red-500" />
                    <StatCard icon={Clock} label="In progress" value={counts.inProgress} tone="bg-amber-50 text-amber-500" />
                    <StatCard icon={CheckCircle2} label="Resolved" value={counts.resolved} tone="bg-green-50 text-green-500" />
                </div>

                {/* Table card */}
                <div className="w-full rounded-2xl border border-gray-200 bg-white shadow-sm">
                    {/* Header */}
                    <div className="flex flex-col gap-4 border-b border-gray-100 p-6 sm:flex-row sm:items-center sm:justify-between">
                        <div>
                            <h2 className="text-lg font-bold text-gray-900">Raised tickets</h2>
                            <p className="mt-1 text-sm text-gray-500">
                                {filtered.length} of {tickets.length} tickets need resolution
                            </p>
                        </div>

                        <div className="flex flex-col gap-3 sm:flex-row sm:items-center">
                            <div className="relative">
                                <Search className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-gray-400" />
                                <input
                                    type="text"
                                    value={query}
                                    onChange={(e) => setQuery(e.target.value)}
                                    placeholder="Search ticket, name, centre..."
                                    className="w-64 rounded-lg border border-gray-200 bg-gray-50 py-2 pl-9 pr-3 text-sm text-gray-700 placeholder-gray-400 outline-none focus:border-gray-300 focus:bg-white"
                                />
                            </div>

                            <div className="relative">
                                <select
                                    value={statusFilter}
                                    onChange={(e) => setStatusFilter(e.target.value)}
                                    className="appearance-none rounded-lg border border-gray-200 bg-white py-2 pl-3 pr-8 text-sm text-gray-700 outline-none focus:border-gray-300"
                                >
                                    {statuses.map((s) => (
                                        <option key={s} value={s}>
                                            {s}
                                        </option>
                                    ))}
                                </select>
                                <ChevronDown className="pointer-events-none absolute right-2 top-1/2 h-4 w-4 -translate-y-1/2 text-gray-400" />
                            </div>

                            <div className="relative">
                                <select
                                    value={priorityFilter}
                                    onChange={(e) => setPriorityFilter(e.target.value)}
                                    className="appearance-none rounded-lg border border-gray-200 bg-white py-2 pl-3 pr-8 text-sm text-gray-700 outline-none focus:border-gray-300"
                                >
                                    {priorities.map((p) => (
                                        <option key={p} value={p}>
                                            {p}
                                        </option>
                                    ))}
                                </select>
                                <ChevronDown className="pointer-events-none absolute right-2 top-1/2 h-4 w-4 -translate-y-1/2 text-gray-400" />
                            </div>

                            <DateFilterDropdown
                                dateFilter={dateFilter}
                                customRange={customRange}
                                onChange={handleDateFilterChange}
                            />
                        </div>
                    </div>

                    {/* Table */}
                    <div className="overflow-x-auto">
                        <table className="w-full min-w-[1100px] table-fixed border-collapse text-left">
                            <thead>
                                <tr className="bg-gray-50 text-xs uppercase tracking-wide text-gray-400">
                                    <th className="w-[24%] px-6 py-3 font-medium">Ticket</th>
                                    <th className="w-[13%] px-6 py-3 font-medium">Raised by</th>
                                    <th className="w-[11%] px-6 py-3 font-medium">Category</th>
                                    <th className="w-[9%] px-6 py-3 font-medium">Priority</th>
                                    <th className="w-[11%] px-6 py-3 font-medium">Status</th>
                                    <th className="w-[11%] px-6 py-3 font-medium">Date</th>
                                    <th className="w-[13%] px-6 py-3 font-medium">Assigned to</th>
                                    <th className="w-[8%] px-6 py-3 font-medium">Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {loading && (
                                    <tr>
                                        <td colSpan={8} className="px-6 py-10 text-center text-sm text-gray-400">
                                            <div className="flex items-center justify-center gap-2">
                                                <Loader2 className="h-4 w-4 animate-spin" /> Loading tickets...
                                            </div>
                                        </td>
                                    </tr>
                                )}

                                {!loading && loadError && (
                                    <tr>
                                        <td colSpan={8} className="px-6 py-10 text-center text-sm text-red-500">
                                            {loadError}{" "}
                                            <button onClick={fetchTickets} className="ml-2 font-semibold underline">
                                                Retry
                                            </button>
                                        </td>
                                    </tr>
                                )}

                                {!loading && !loadError && filtered.map((t, idx) => (
                                    <tr
                                        key={t.id}
                                        className={`text-sm ${idx !== filtered.length - 1 ? "border-b border-gray-100" : ""}`}
                                    >
                                        <td className="px-6 py-4">
                                            <p className="font-semibold text-gray-900">{t.subject}</p>
                                            <p className="mt-0.5 text-xs text-gray-400">
                                                {t.displayId} · {t.centre}
                                            </p>
                                        </td>
                                        <td className="px-6 py-4 text-gray-600">
                                            <div className="flex items-center gap-2">
                                                <User className="h-4 w-4 shrink-0 text-gray-400" />
                                                <span className="truncate">{t.raisedBy}</span>
                                            </div>
                                        </td>
                                        <td className="px-6 py-4 text-gray-600">{t.category}</td>
                                        <td className="px-6 py-4">
                                            <span className={`inline-flex rounded-full px-3 py-1 text-xs font-medium ${PRIORITY_STYLES[t.priority] || PRIORITY_STYLES.Low}`}>
                                                {t.priority}
                                            </span>
                                        </td>
                                        <td className="px-6 py-4">
                                            <span className={`inline-flex rounded-full px-3 py-1 text-xs font-medium ${STATUS_STYLES[t.status] || STATUS_STYLES.Open}`}>
                                                {t.status}
                                            </span>
                                        </td>
                                        <td className="px-6 py-4 text-gray-500">
                                            <div className="flex items-center gap-1.5">
                                                <Calendar className="h-4 w-4 shrink-0 text-gray-400" />
                                                {t.date}
                                            </div>
                                        </td>
                                        <td className="px-6 py-4 text-gray-600">
                                            {t.assignedTo === "Unassigned" ? (
                                                <span className="text-gray-400">Unassigned</span>
                                            ) : (
                                                t.assignedTo
                                            )}
                                        </td>
                                        <td className="px-6 py-4">
                                            <button
                                                onClick={() => setActiveTicketId(t.id)}
                                                className="flex items-center gap-1.5 rounded-lg border border-gray-200 px-3 py-1.5 text-xs font-semibold text-gray-600 transition hover:border-gray-300 hover:bg-gray-50"
                                            >
                                                <Eye className="h-3.5 w-3.5" /> View
                                            </button>
                                        </td>
                                    </tr>
                                ))}

                                {!loading && !loadError && filtered.length === 0 && (
                                    <tr>
                                        <td colSpan={8} className="px-6 py-10 text-center text-sm text-gray-400">
                                            No tickets match your filters.
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

            {activeTicket && (
                <TicketModal
                    ticket={activeTicket}
                    onClose={() => setActiveTicketId(null)}
                    onUpdateStatus={updateTicketStatus}
                    saving={savingTicketId === activeTicket.id}
                />
            )}
        </div>
    );
}